<script setup lang="ts">
import {computed, defineProps} from "vue";
import type { Hierarchy } from "#/BTNode";
import {debug} from "@/store/bt";
import BenefitsScaleCaption from "@/bt/BenefitsScaleCaption.vue";

const props = defineProps<{ nodes: Hierarchy[] }>();

function getNodesAtDepth(nodes: Hierarchy[], depth: number): Hierarchy[] {
  if (depth === 1) return nodes;
  let children: Hierarchy[] = [];
  for (const node of nodes) {
    if (node.children) {
      children = children.concat(getNodesAtDepth(node.children, depth - 1));
    }
  }
  return children;
}

function getDepth(node: Hierarchy): number {
  if (!node.children || node.children.length === 0) return 1;
  return 1 + Math.max(...node.children.map(getDepth));
}

const maxDepth = computed(() => {
  if (!props.nodes || props.nodes.length === 0) return 0;
  return Math.max(...props.nodes.map(getDepth));
});
</script>

<template>
  <tr v-for="(row,i) in maxDepth" :key="row">
    <th v-if="i === 0" :rowspan="maxDepth + 1" colspan="2">
      <BenefitsScaleCaption :nodes="props.nodes" />
    </th>
    <template v-for="node in getNodesAtDepth(props.nodes, row)">
      <th v-if="row < maxDepth" :colspan="node.childrenCount ?? 1" :data-id="node.id">
        {{ node.name }} <span v-if="debug"> - i: {{ i }} -  row: {{ row }} - maxDepth: {{ maxDepth }}</span>
      </th>
      <th v-else>
        {{ node.name.substring(0, node.name.indexOf(' -')) }}
      </th>
    </template>
  </tr>
  <!-- last thead row -->
  <tr>
    <template v-for="node in getNodesAtDepth(props.nodes, maxDepth)">
      <th :colspan="node.childrenCount ?? 1" :data-id="node.id">
        <a :href="node.href">{{ node.name.substring(node.name.indexOf(' - ') + 3, 999) }}</a>
        <em v-if="debug"><br /> - id: {{ node.id }}</em>
      </th>
    </template>
  </tr>
</template>
